import React, { useEffect, useState } from "react";
import { LayoutList, ArrowLeft } from "lucide-react";
import { useParams, useNavigate } from "react-router-dom";
import { isValidGUID } from "@/utils/validation";
import { notFoundUrl, dataMappingModuleUrl } from "@/routes/urls";
import Background from "@/components/ui/Background";
import NavigationCard from "@/components/common/NavigationCard";
import { IconButton } from "@/components/ui/IconButton";
import ClientInfo from "@/components/ClientInfo";
import AccountMappingSubModule from "@/components/datamapping/AccountMappingSubModule";

const DataMappingModule: React.FC = () => {
  const navigate = useNavigate();
  const { clientId, submodule } = useParams<{
    clientId: string;
    submodule?: string;
  }>();
  const [title, setTitle] = useState<string>("Data Mapping");

  useEffect(() => {
    if (!clientId || !isValidGUID(clientId)) {
      navigate(notFoundUrl);
    }
    if (!submodule) {
      setTitle("Data Mapping");
    } else if (submodule === "accounts") {
      setTitle("Data Mapping: Kontoplan");
    } else {
      navigate(notFoundUrl);
    }
  }, [navigate, clientId, submodule]);

  const navigateSubModule = (submodule) => {
    navigate(
      dataMappingModuleUrl
        .replace(":clientId", clientId!)
        .replace(":submodule", submodule)
    );
  };

  return (
    <Background className="px-4 py-4">
        <div className="flex items-start mt-2 mb-2 justify-between h-12">
            <div className="flex items-center justify-left">
                <IconButton 
                    disabled={!submodule} 
                    onClick={() => navigateSubModule("")}
                    className="bg-palette-primary text-white hover:bg-palette-primary-dark"
                >
                    <ArrowLeft />
                </IconButton>
                <h1 className="text-3xl font-bold">{title}</h1>
            </div>
            <ClientInfo useLoadingSpinner={false}/>
        </div>
      
      {!submodule && (
        <NavigationCard
          title={"Kontoplan"}
          description={"Gruppera och konfigurera kontostrukturer"}
          icon={<LayoutList />}
          onClick={() => navigateSubModule("accounts")}
        />
      )}
      {submodule === "accounts" && <AccountMappingSubModule clientId={clientId} />}
    </Background>
  );
};

export default DataMappingModule;
